import { render, staticRenderFns } from "./GestionDroit.vue?vue&type=template&id=06011b4d"
import script from "./GestionDroit.vue?vue&type=script&lang=js"
export * from "./GestionDroit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports